import * as React from 'react';
import { useMessageBus } from '../components/realtime/messagebus/useMessageBus';
/**
 * This is similar to useEffect hook in react.
 * This is more like a advanced version of react useEffect. Here callback function get executed not only when the dependencies changes, but in regular intervals.
 * Also you can push a message through message bus to trigger the callback
 *
 * @export
 *
 * @example
 * ```
 * useEffectWithPolling(props.uxpContext, "visitor-arrivals", 5000, getVisitors, [props])
 * ```
 */
const useEffectWithPolling = (context, channel, interval, callback, deps) => {
    // this will used to trigger the use effect along with other dependencies 
    let [tick, setTick] = React.useState(0);
    // timer 
    let timerRef = React.useRef(null);
    // add tick to dependencies
    let newDeps = deps.slice();
    newDeps.push(tick);
    // clear timer
    function clearTimer() {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
    }
    // set timer
    function startTimer() {
        clearTimer();
        timerRef.current = setTimeout(() => {
            setTick((x) => x + 1);
        }, interval);
    }
    React.useEffect(() => {
        clearTimer();
        // callback
        callback().then(() => {
            startTimer();
        }).catch(e => {
            console.log('Error in useEffectWithPolling', channel, e);
            startTimer();
        });
        return () => clearTimer();
    }, newDeps);
    useMessageBus(context, channel, (p, ch) => {
        console.log("UE With Polling:Message Recieved. channel : ", ch, ' payload: ', p);
        setTick((x) => x + 1);
        return "";
    });
};
export default useEffectWithPolling;
